var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeTrialGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 277.42 277.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -397.58,
    y1: 375.94,
    x2: -459.67,
    y2: 322.96,
    gradientTransform: "translate(486.84 -283.02) rotate(-9.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2052.13,
    y1: 6330.46,
    x2: -1811.74,
    y2: 6339.4,
    gradientTransform: "translate(-6469.25 -830.57) rotate(-99.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -426.42,
    y1: 304.81,
    x2: -506.21,
    y2: 412.08,
    gradientTransform: "translate(486.84 -283.02) rotate(-9.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -718.2,
    y1: 536.77,
    x2: -713.78,
    y2: 536.77,
    gradientTransform: "translate(631.75 -585.54) rotate(-15.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb6fbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -711.62,
    y1: 536.28,
    x2: -707.2,
    y2: 536.28,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -705.05,
    y1: 535.21,
    x2: -700.63,
    y2: 535.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -698.47,
    y1: 533.49,
    x2: -694.05,
    y2: 533.49,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -691.9,
    y1: 530.98,
    x2: -687.48,
    y2: 530.98,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -718.95,
    y1: 520.05,
    x2: -683.72,
    y2: 520.05,
    xlinkHref: "#linear-gradient-4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 74.35,
    width: 156.5,
    height: 129.11,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,126.58a9.22,9.22,0,0,0-2.36-2.12c-.82-.26-2.41-1.49-2.62-1s1.07,1.29,1,1.87-4.06,1.51-4,2.13a2.36,2.36,0,0,0,2.47,1.93c1.52-.17,5.39-1.09,6.18-.69S149.62,126.58,149.62,126.58Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,117.54a32.56,32.56,0,0,1-7.61,7.32,42,42,0,0,1-18,6.9c-2.24-.72-9.14-1.47-13.21-2.12h0c-1.78-.29-3-.56-3.1-.8l.1-3.54s14.95-.8,17.43-1.94a56.33,56.33,0,0,0,9.6-11.15,14.36,14.36,0,0,1,7.53-6.25C188.65,104.15,197.86,108.13,190.85,117.54Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,122.63l-.76,2.23a42,42,0,0,1-18,6.9c-1.8,0-9.14-1.47-13.21-2.12.16,0,11.09.86,13.51.61s13.76-10.07,13.76-10.07Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,235.07h16.52c1.18-.8-.32-8.65-.32-8.65s-4.51-1.71-5.29,1.77-5.74,4.58-8.37,5A2.84,2.84,0,0,0,174.24,235.07Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,235.07h16.53c1.18-.8-.32-8.65-.32-8.65s-4.51-1.71-5.29,1.77-5.75,4.58-8.37,5A2.84,2.84,0,0,0,198.74,235.07Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.68,155s.75,9.26,1.62,20.4c1.18,15.13,4.38,52.64,4.38,52.64s2.1,1.79,6.75.81a147.41,147.41,0,0,0,5.14-27.71c0-.24,0-.48.05-.73,1.1-15,2.81-46.7,2.81-46.7Z",
    style: {
      fill: "#2b478b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.43,151.8s1,12.46,1.87,23.6l16.27,25.74c0-.24,0-.48.05-.73,1.1-15,2.81-46.7,2.81-46.7Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.17,151.8s11.8,29.37,15.57,40.5c2.69,7.93,10.27,35.75,10.27,35.75a7.61,7.61,0,0,0,6.06-.94s2.82-28.42-2.87-36.43c-3-4.26-.75-44.2-13-44.55S183.17,151.8,183.17,151.8Z",
    style: {
      fill: "#2b478b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,108.5a7.31,7.31,0,0,0,5.08.68,11,11,0,0,0,4.84-2.5l-.17-.26c-.53-.91-2.14-4.18-1.42-9.44a3.7,3.7,0,0,0-1.3.22c-2.34.55-7.05,1.89-7.26,1.94h0s0,1.11-.25,3.09c0,.18,0,.36,0,.55s-.05.48-.08.73A16.68,16.68,0,0,0,188.44,108.5Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,102.23c3.5.8,8.71-4.36,8.71-4.36a5.64,5.64,0,0,0-1.19-.67c-2.34.55-7.05,1.89-7.26,1.94h0S188.15,100.25,188,102.23Z",
    style: {
      fill: "#ed975d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,98.86a17.56,17.56,0,0,0,3.26.77c2.68.36,6.21.15,7.31-3.1,1.87-5.45,4.25-8.72-1.24-11-2.93-1.2-4.81-1.26-6.09-.8a4.4,4.4,0,0,0-2.26,2C186.69,88.4,184.55,97.91,186.77,98.86Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,87.16c3.17,2.28,7.57,0,8.93.65S194,90.7,194,91.43s.12,1.34,2,.9a.9.9,0,0,1,.67,0c.77.46-.21,2.67-.51,3.15,0,0-.42,1.58.52,2.35.12.1,2,.91,6.46-6a6.37,6.37,0,0,0,.28-5.83c-1.08-2.33-5.62-4.59-9.47-5.79a5.19,5.19,0,0,0-3.35-.12c-1.39.51-2.14,1.83-2.88,3.15A12.06,12.06,0,0,1,183.44,87.16Z",
    style: {
      fill: "#a9453d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,153.85s-1.54.33-3.49.66a38.13,38.13,0,0,1-5.81.62,52.36,52.36,0,0,1-15.22-2.5c-1.56,0-2.27-2.41-2.52-5.78a65.71,65.71,0,0,1,0-7.7c0-.88.09-1.75.14-2.61.11-1.7.24-3.33.35-4.78s.21-2.54.27-3.47c0,0-.22-6.44-.13-12.12a15.46,15.46,0,0,1,2.91-8.38c1.66-1.75,6.47-2.86,7.43-3l.11,0c4,2.22,9.27-.78,9.27-.78l.36.07a20.34,20.34,0,0,1,5.31,1c2.3,1.25,3.64,15.14,3.64,15.14.38,9.44-.1,24.56.64,30.33C207.38,152.44,205.54,153.46,203.88,153.85Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,104.06s-5.88,6.07-10.09,4.83c0,0-.56-.82,1.33-1.09S192.69,107.65,197.51,104.06Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.72,95.34s-.11.71,1.53,1.27c0,0,1.38.48,1.63-.25A4.69,4.69,0,0,0,186.72,95.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,127s-8.55,14.3-13.4,16.82a37.13,37.13,0,0,1-10.5,3,65.71,65.71,0,0,1,0-7.7c3.47-.42,8.76-1.09,8.76-1.09Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.48,119.85l-4.56,16.45s-5.36.34-7.95.24c.11-1.7.11-1.76.23-3.2C177.2,133.34,183.36,130.13,189.48,119.85Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,137.51a9.22,9.22,0,0,0-2.36-2.12c-.82-.26-2.41-1.49-2.62-1s1.07,1.29,1,1.87-4.06,1.52-4,2.13a2.36,2.36,0,0,0,2.47,1.93c1.52-.17,5.39-1.09,6.18-.69S162,137.51,162,137.51Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,114.69s.27,8.71-19.59,26.19l-4-7.14c-.73-.43,12.83-29.6,16.73-29.37C207.66,104.83,207,114.69,207,114.69Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.76,132.89s-22.58,2.58-23.42,3-2.63,2.2-2,4.39c0,0,11.69,1.47,18.12,1.44a42.42,42.42,0,0,0,9.14-.91Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,42.43l21,129.35c.31,1.93-1.17,2.74-2.92,3.24l-61.83,19.1-1,.28a3.31,3.31,0,0,1-4.25-2.73L51.09,52.79a3.71,3.71,0,0,1,3.11-4.3l1.35-.19,64.15-6.08C121.48,42,122.29,40.5,122.6,42.43Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,42.09l20.94,129.22a4,4,0,0,1-2.6,4.43l-63,18.15a3.3,3.3,0,0,1-4.24-2.73L53.13,52.43a3.7,3.7,0,0,1,3.1-4.3L120.68,39A3.52,3.52,0,0,1,124.5,42.09Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65,49.56l19.42,119.83a3.7,3.7,0,0,1-2.43,4.13l-59.25,16.9a3.07,3.07,0,0,1-3.94-2.55L56.68,59.77a3.5,3.5,0,0,1,2.88-4l60.52-9A3.26,3.26,0,0,1,123.65,49.56Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light",
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.57,122.49c-8.28-14.38-23.54-8.54-31-23.37-6.14-12.15,1.73-20.73-4.19-35-3.34-8-9.26-13.57-15-17.45L56.23,48.13a3.7,3.7,0,0,0-3.1,4.3L75.62,191.16a3.3,3.3,0,0,0,4.24,2.73l48.61-14a42,42,0,0,1-8.81-16.15C114.76,146.29,124.12,135.59,116.57,122.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,108c2.42,15-7.15,29.77-21.62,33.14-14.74,3.44-28.93-6.27-31.44-21.73S82.72,89,97.55,86.09C112.1,83.23,125.67,93.06,128.09,108Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,121.63l3,10.66,4.25-1.2-3-10.65q-1.16.41-2.07.66C87.08,121.4,86.32,121.55,85.93,121.63Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2,119.66l3.08,10.84,4.25-1.21-3.29-11.6-.46.25C94.51,118.63,93.31,119.19,92.2,119.66Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61,128.7l4.25-1.2L102,113.83a45.72,45.72,0,0,1-3.82,2.72Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,112.3l4.14,14.61,4.25-1.21-4.82-17c-.82.92-1.67,1.8-2.56,2.64C104.47,111.68,104.13,112,103.79,112.3Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,106.74l5.22,18.37,4.25-1.2-6.19-21.81A48.82,48.82,0,0,1,109,106.74Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.66,92.71l-3,2-3,2a.66.66,0,0,0,.07,1.14l2.06,1a40.2,40.2,0,0,1-14.9,14.82,27.87,27.87,0,0,1-8.48,3.21,1.39,1.39,0,0,0,.4,2.75,18.06,18.06,0,0,0,2.21-.51,34.22,34.22,0,0,0,7.09-3,40.15,40.15,0,0,0,8.45-6.23,46,46,0,0,0,7.73-9.86l1.91.94a.66.66,0,0,0,1-.63l-.24-3.6-.25-3.59A.66.66,0,0,0,112.66,92.71Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrialGraphic);
export default __webpack_public_path__ + "static/media/free_trial_graphic.de1b4f1c05da3ec50b3d4539baf5b8e6.svg";
export { ForwardRef as ReactComponent };